import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import SvGraphics from "../../../assets/SvGraphics";
import {authenticationService} from "../../../services/AuthenticationService";
import * as Yup from "yup";
import Error from "../../../components/single_components/Error";
import UpdateFiles from "../../../components/PatientOnboard/UpdateFiles";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import SelfUpdateFiles from "../../../components/Patient_SelfOnboard/SelfUpdateFiles";


class SelfSymptomsTargetsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symptomsArr: this.props.symptoms,
            entry: this.props.entry,
            symptomsList: this.props.symptomsList,

        };
    }
    componentWillMount() {
    }
    onclickIndication(name,value){
        this.props.onValueChange(name, value)
        if(name !=="I_other"){
            this.props.onValueChange("other_patient_type_indication", "")
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    addFileObj = (index,selectedCategory,selectedFile) => {
        this.props.addFileObj(index,selectedCategory,selectedFile)
    }

    deleteUploadedFile=(index) => {
        this.props.deleteUploadedFile(index)
    }
    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    render() {

        let {symptomsArr,entry,symptomsList} = this.state
        let {t} = this.props
        let currentUser=authenticationService.currentUserValue;
        let language=localStorage.getItem('language')
        let symptomsListArr=[]
        if(language==="he"){
            symptomsListArr= symptomsList.map( item=>
                <option value={item.Symptom_ID}>{item.Symptom_description_he}</option>)
        }else{
            symptomsListArr= symptomsList.map( item=>
                <option value={item.Symptom_ID}>{item.Symptom_description}</option>)
        }


        let targetSymptoms=[]


        targetSymptoms = symptomsArr.map((item, index) =>
                <div className={'self_symptomsBlock'}>
                <div className={'patientsFormRow'}>
                <div className={'inputSlots'}>
                    <label className={'infoLabel'}>{t('patient_self_boarding.choose_symptom')}</label>
                    <select className={'selectBox'} id="SymptomsInputSelect" name="Symptom_ID" value={item.Symptom_ID ?item.Symptom_ID.substring(1):""}
                        onChange={event => this.props.onClickTargetSymptom(item.Symptom_ID , event.target.id, event.target.value)}>
                        <option/>
                        {symptomsListArr}
                    </select>
                </div>
                    <div className={'inputSlots'} style={{marginTop:'40px'}}>

                    <SvGraphics className={"delete-icon-self-onboarding"}
                                onClick={() => this.props.addDeleteTargetSymptom(item)} svgname={'delete-icon'}/>
                    </div>
                    <div className={'inputSlots'} style={{display:item.Symptom_ID&&item.Symptom_ID.substring(1)==="51"?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.enter_symptom')}</label>
                        <input className={'inputBoxStyle'} type="text" name="OtherSymptom" id="OtherSymptom"
                               defaultValue={item.OtherSymptom}
                               onChange={event => this.props.onClickTargetSymptom(item.Symptom_ID, event.target.id, event.target.value)}/>
                    </div>
                </div>
            </div>
        )
        return (
            <div>
                <div  className={'patientForm-box-container'}>

                    <div className={'patientsFormBoxes-title-text'}>
                        <label className={'patientsFormBoxes-title-text-label'}>{t('patient_self_boarding.symptoms_choose')}</label>
                    </div>

                    <div className={'patientsFormBoxes'}>
                        {targetSymptoms}
                        <div className={'svg-label'} onClick={() => this.props.addDeleteTargetSymptom("Add")}>
                            <SvGraphics className={"delete-icon"} svgname={'add-icon'}/>
                            <div className={'addTarget'} >{t('patient_self_boarding.add_symptom')}</div>
                        </div>
                    </div>

                    <div className={'patientsFormRow'}>
                    </div>



                </div>

                <FormElementContainer title={t('patient_self_boarding.upload_files')}
                                      Component={SelfUpdateFiles}
                                      rest={{
                                          isUploadingFiles:this.props.isUploadingFiles,
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          addFileObj:(index,selectedCategory,selectedFile) => this.addFileObj(index,selectedCategory,selectedFile),
                                          deleteUploadedFile:(index) => this.deleteUploadedFile(index),
                                          entry:this.props.entry,
                                          addedFilesList:this.props.addedFilesList,
                                          otherForms:this.props.fileForms,
                                          errors:this.props.errors,
                                          t:(e) => this.props.t(e)
                                      }}/>
            </div>
        );
    }
}



const SelfSymptomsTargetsTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(SelfSymptomsTargetsTabComposed);

export default SelfSymptomsTargetsTab;

